module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_counter-pic-1992da85d13be5df8454f7dae66da5ee.png";